import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import shipping from "src/assets/shipping.png";

interface Props {
  page: string;
}

const ShippingDisclaimer = ({ page }: Props) => {
  const component = "shipping-disclaimer";
  const { t } = useTranslation();

  return (
    <Stack
      sx={{ backgroundColor: "#D5F8F8", borderRadius: "10px" }}
      p={2}
      direction="row"
      height="min-content"
      justifyContent="space-between"
    >
      <Stack gap={1}>
        <Typography fontWeight={600} variant="h6">
          {t(`${page}.${component}.header`)}
        </Typography>
        <Typography>{t(`${page}.${component}.text`)}</Typography>
      </Stack>
      <Box
        component="img"
        src={shipping}
        alt="shipping-information"
        sx={{
          borderRadius: "10px",
          width: "106px",
          height: "128px",
          aspectRatio: "53/67",
          flexShrink: 0,
        }}
      />
    </Stack>
  );
};

export default ShippingDisclaimer;
